var _path, _path2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgDownloadExport(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M0.5 12C0.5 5.62614 5.62614 0.5 12 0.5C18.3739 0.5 23.5 5.62614 23.5 12C23.5 18.3739 18.3739 23.5 12 23.5C5.62614 23.5 0.5 18.3739 0.5 12Z",
    stroke: "#00A3E0"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M7.65 13.35C7.45 13.15 7.45 12.85 7.65 12.65C7.85 12.45 8.15 12.45 8.35 12.65L11.5 15.8V5C11.5 4.7 11.7 4.5 12 4.5C12.3 4.5 12.5 4.7 12.5 5V15.8L15.65 12.65C15.85 12.45 16.15 12.45 16.35 12.65C16.55 12.85 16.55 13.15 16.35 13.35L12.35 17.35C12.3 17.4 12.25 17.45 12.2 17.45C12.15 17.5 12.05 17.5 12 17.5C11.95 17.5 11.85 17.5 11.8 17.45C11.75 17.4 11.7 17.4 11.65 17.35L7.65 13.35ZM17 16.5C16.7 16.5 16.5 16.7 16.5 17V18.5H7.5V17C7.5 16.7 7.3 16.5 7 16.5C6.7 16.5 6.5 16.7 6.5 17V19C6.5 19.3 6.7 19.5 7 19.5H17C17.3 19.5 17.5 19.3 17.5 19V17C17.5 16.7 17.3 16.5 17 16.5Z",
    fill: "#00A3E0"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgDownloadExport);
export default __webpack_public_path__ + "static/media/download-export.c9cc8631631b5b653736d91c8a45a4d1.svg";
export { ForwardRef as ReactComponent };